/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';

import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router';
import styles from './styles.scss';

const defaultProps = {
  message: '',
  closeButton: false,
  onHide: () => {},
};

const propTypes = {
  show: React.PropTypes.bool.isRequired,
  azStyle: React.PropTypes.string.isRequired,
  message: React.PropTypes.node,
  closeButton: React.PropTypes.bool,
  onHide: React.PropTypes.func,
};

class FormBlock extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      message: props.message,
      azStyle: props.azStyle,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { show, message, azStyle } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (message !== this.props.message) {
      this.setState({ message });
    }
    if (azStyle !== this.props.azStyle) {
      this.setState({ azStyle });
    }
  }

  render() {
    const { closeButton = false, onHide } = this.props;
    const { show, message, azStyle } = this.state;
    return (
      <Collapse in={show}>
        <div>
          <div className={`${styles.formBlock} ${styles[azStyle]}`}>
            {message}
            {closeButton && (
              <Link className={styles.closeButton} onClick={onHide}>
                <i className="fa fa-times" />
              </Link>
            )}
          </div>
        </div>
      </Collapse>
    );
  }
}

FormBlock.defaultProps = defaultProps;
FormBlock.propTypes = propTypes;

export default FormBlock;




// WEBPACK FOOTER //
// ./src/components/FormBlock/index.jsx